/**
 * Created by pandemio on 4/1/19.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody} from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Modal to ask if the user wants to attach the user to the subscription
 */
class ModalAttachProfile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visibleModalAttach: this.props.visibleModalAttach,
            answer: false,
            studentName: this.props.studentName
        };
        this.toggle = this.toggle.bind(this);
        this.toogleYes = this.toogleYes.bind(this);
        this.toogleNo = this.toogleNo.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });
    }

    /**
     * Toogles when yes
     */
    toogleYes(){
        this.setState({
            modal: !this.state.modal,
            answer: true
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });

    }

    /**
     * Toogles when no
     */
    toogleNo(){
        this.setState({
            modal: !this.state.modal,
            answer: false
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.visibleModalAttach} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="general.attention" />
                    </ModalHeader>
                    <ModalBody>
                        <Translate id="subscription-set-profile-existing-account.are-you-sure-profile-to-subscription" />
                        <h3>{this.state.studentName}</h3>
                        <hr/>
                        <p style={{textAlign: 'right'}}>
                            <Button color="success" onClick={this.toogleYes}>
                                <Translate id="subscription-set-profile-existing-account.yes" />
                            </Button>
                            <Button color="warning" onClick={this.toogleNo}>
                                <Translate id="subscription-set-profile-existing-account.no" />
                            </Button>
                        </p>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default ModalAttachProfile;